import { useCallback } from 'react';

const useOrderCalculation = (listorder, transactionType) => {
  const calculateOrder = useCallback((item, index) => {
    if (!item) return null;
    if (item?.isGold_bar === true || item?.isGoldbar === true) {
      return {
        ...item,
        calculations: {
          pricebackperbath: 0,
          pricebackpergram: 0,
          pricebackpergramfix: 0,
          pricebackperbathtotal: 0,
          totalbeforeVat: item.cost,
          baseVat: 0,
          baseTotalVat: 0,
          vat: 0,
          totalWithVat: item.cost,
        },
      };
    }
    if (item?.place === 'คลังอื่นๆ') {
      const vat = (item.cost * 0.07).toFixed(2);
      const totalbeforeVat = (item.cost - vat).toFixed(2);
      return {
        ...item,
        calculations: {
          pricebackperbath: 0,
          pricebackpergram: 0,
          pricebackpergramfix: 0,
          pricebackperbathtotal: 0,
          totalbeforeVat: parseFloat(totalbeforeVat),
          baseVat: 0,
          baseTotalVat: 0,
          vat: parseFloat(vat),
          totalWithVat: item.cost,
        },
      };
    }
    const pricebackperbath = (item?.gold_official - 100) * 0.98; // ราคาทองคำรับซื้อต่อบาท (D)
    const pricebackpergram =
      item?.materialTypeVat === 1.036
        ? pricebackperbath / 15.16
        : Math.round(pricebackperbath / 15.16); // ราคาซื้อคืนต่อกรัม (C1)
    let pricebackpergramfix;
    if (item?.materialTypeVat === 1) {
      pricebackpergramfix = pricebackpergram;
    } else if (item?.materialTypeVat === 1.036) {
      pricebackpergramfix = Math.round(
        pricebackpergram * item?.materialTypeVat,
      ); //ทำ2 ตำแหน่ง
    } else if (
      item?.materialTypeVat === 0.35 ||
      item?.materialTypeVat === 0.45
    ) {
      pricebackpergramfix = Math.round(
        pricebackpergram * item?.materialTypeVat,
      );
    } else {
      pricebackpergramfix =
        Math.round(pricebackpergram * item?.materialTypeVat * 10) / 10; //ทำ1 ตำแหน่ง
    }
    const pricebackperbathtotal = (pricebackpergramfix * 15.16).toFixed(2);

    let totalbeforeVat = (
      item?.cost -
      ((item?.cost - pricebackpergramfix * item?.weight) * 7) / 107
    ).toFixed(2);
    // console.log(
    //   'cal 99',
    //   pricebackpergramfix,
    //   totalbeforeVat,
    //   pricebackpergram,
    //   pricebackperbath,
    //   item?.gold_official,
    // );

    const baseVat = item?.weight * pricebackpergramfix.toFixed(2); //มูลค่ารับซื้อคืน
    const baseTotalVat =
      totalbeforeVat - baseVat > 0 ? (totalbeforeVat - baseVat)?.toFixed(2) : 0;
    let vat = baseTotalVat > 0 ? (item?.cost - totalbeforeVat)?.toFixed(2) : 0;
    if (transactionType === 'BUY' && item?.place === 'คลังรูปพรรณเก่า') {
      vat = 0;
      totalbeforeVat = item?.cost;
    } else {
      totalbeforeVat =
        item?.cost - totalbeforeVat > 0 ? totalbeforeVat : item?.cost;
    }
    // console.log(
    //   'priceback',
    //   pricebackpergramfix,
    //   item,
    //   baseVat,
    //   pricebackpergram,
    //   item?.materialTypeVat,
    // );
    return {
      ...item,
      calculations: {
        pricebackperbath,
        pricebackpergram,
        pricebackpergramfix,
        pricebackperbathtotal: parseFloat(pricebackperbathtotal),
        totalbeforeVat: parseFloat(totalbeforeVat),
        baseVat: parseFloat(baseVat),
        baseTotalVat: parseFloat(baseTotalVat),
        vat: parseFloat(vat),
        totalWithVat: parseFloat(totalbeforeVat) + parseFloat(vat),
      },
    };
  }, []);

  const getCalculatedOrders = useCallback(() => {
    if (!listorder || !Array.isArray(listorder) || listorder.length === 0) {
      return [];
    }

    return listorder
      .map((item, index) => calculateOrder(item, index))
      .filter(Boolean);
  }, [listorder, calculateOrder]);

  const getCalculation = useCallback(
    (index) => {
      const calculatedOrders = getCalculatedOrders();
      return calculatedOrders[index]?.calculations || null;
    },
    [getCalculatedOrders],
  );

  const getTotalSummary = useCallback(() => {
    const calculatedOrders = getCalculatedOrders();
    return calculatedOrders.reduce(
      (summary, order) => {
        const calc = order.calculations;
        return {
          totalBeforeVat: summary.totalBeforeVat + calc.totalbeforeVat,
          totalVat: summary.totalVat + calc.vat,
          grandTotal: summary.grandTotal + calc.totalWithVat,
        };
      },
      { totalBeforeVat: 0, totalVat: 0, grandTotal: 0 },
    );
  }, [getCalculatedOrders]);

  const generateOrderData = useCallback(() => {
    const calculatedOrders = getCalculatedOrders();

    return calculatedOrders.map((item, index) => {
      const calc = item.calculations;
      console.log('item', item);

      return {
        material_id: item?.material,
        material: {
          _id: item?.material,
          name: item?.materialname,
          isGold_bar: item?.isGold_bar,
          unit: item?.materialunit,
          note: item?.noteMaterial,
        },
        material_typename: item?.materialTypeName,
        materialTypeVat: item?.materialTypeVat, //เปอร์เซน
        material_type: item?.materialTypeId,
        quantity: item?.quantity,
        place: item?.place,
        gold_official: item?.gold_official, //ราคาปัจจุบันทองขาย(W)
        pricebackpergram: Number(calc.pricebackpergramfix), //ราคาซื้อคืนต่อกรัม (C1)
        pricebackperbath: Number(calc.pricebackperbath), //ราคาซื้อคืนต่อบาท  (D)
        pricebackperbathtotal: Number(calc.pricebackperbathtotal), //ราคาซื้อคืนต่อบาท 2 ตำแหน่ง
        totalbeforeVat: Number(calc.totalbeforeVat), //ราคารวมก่อน vat (Z)
        baseVat: Number(calc.baseVat), //มูลค่ารับซื้อคืน (E)
        baseTotalVat: Number(calc.baseTotalVat), //มูลค่ารับซื้อคืน 2 ตำแหน่ง
        vat: Number(calc.vat), //vat
        weight: item?.weight,
        note: item?.note,
        cost: item?.cost,
        price_gold: item?.price_gold,
        image: item?.image || undefined,
      };
    });
  }, [getCalculatedOrders]);

  return {
    calculatedOrders: getCalculatedOrders(),
    getCalculation,
    getTotalSummary,
    generateOrderData,
  };
};

export default useOrderCalculation;
